var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "24.5",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg817494995a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.06 11.37c-.11-.17-.25-.3-.42-.4-.27-.15-.6-.2-.9-.12a12.46 12.46 0 0 0-4.94 2.1 13.47 13.47 0 0 0-3.74 4.06 13.47 13.47 0 0 0-1.64 5.26c-.17 1.83.05 3.65.64 5.33.04.19.12.37.23.52a1.23 1.23 0 0 0 .95.5c.19.02.38-.02.56-.1a1.47 1.47 0 0 0 .82-.82c.07-.18.11-.38.11-.58 0-.2-.04-.39-.12-.56a9.75 9.75 0 0 1-.51-4.14c.13-1.42.55-2.82 1.24-4.1.76-1.23 1.76-2.3 2.93-3.12a9.75 9.75 0 0 1 3.84-1.63 1.51 1.51 0 0 0 1.15-1.65c-.03-.2-.1-.39-.2-.55zm19.03 17.2c.2 0 .38-.06.55-.16.27-.16.47-.41.56-.72.6-1.68.81-3.5.64-5.33a13.47 13.47 0 0 0-1.64-5.26 13.47 13.47 0 0 0-3.73-4.05 12.46 12.46 0 0 0-4.94-2.11 1.32 1.32 0 0 0-.56-.07 1.23 1.23 0 0 0-.92.57c-.1.16-.17.34-.2.53a1.47 1.47 0 0 0 .31 1.13c.12.16.28.29.45.39.17.1.35.16.54.18 1.36.24 2.67.8 3.84 1.62 1.17.82 2.17 1.89 2.93 3.13.7 1.27 1.12 2.67 1.24 4.1a9.75 9.75 0 0 1-.5 4.13 1.51 1.51 0 0 0 .85 1.82c.18.08.38.11.58.1zm-4-.28a.92.92 0 0 1-.41.12 1 1 0 0 1-.44-.07 1.13 1.13 0 0 1-.63-1.36c.34-.97.47-2.02.38-3.08a7.85 7.85 0 0 0-.93-3.05 7.86 7.86 0 0 0-2.18-2.33 7.26 7.26 0 0 0-2.86-1.21 1.03 1.03 0 0 1-.4-.14 1.12 1.12 0 0 1-.53-.69 1.1 1.1 0 0 1-.03-.43 1 1 0 0 1 .14-.4.92.92 0 0 1 1.1-.38c1.3.24 2.56.78 3.68 1.57 1.12.8 2.07 1.83 2.79 3.02.67 1.22 1.09 2.56 1.22 3.92a9.28 9.28 0 0 1-.48 3.97.94.94 0 0 1-.42.54zm-.61 5.45l-2-2.11v-5.2a8.25 8.25 0 0 0-1.81-5.29A7.55 7.55 0 0 0 26 18.4a7.16 7.16 0 0 0-5.92 1.88 7.85 7.85 0 0 0-1.88 2.66 8.19 8.19 0 0 0-.67 3.24v5.45l-2 2.11c-.26.27-.43.6-.5.98a2 2 0 0 0 .1 1.1c.15.34.38.64.68.85.3.21.64.32 1 .33h3.74v.4c.05 1.18.55 2.3 1.38 3.1.84.8 1.94 1.21 3.07 1.16a4.16 4.16 0 0 0 3.07-1.17 4.57 4.57 0 0 0 1.38-3.1V37h3.74c.35 0 .7-.1 1-.32.3-.2.53-.5.67-.85a2 2 0 0 0-.38-2.08zm-7.26 3.65a2.23 2.23 0 0 1-.74 1.44c-.41.36-.94.54-1.48.5a2.03 2.03 0 0 1-1.48-.5 2.23 2.23 0 0 1-.74-1.44V37h4.44v.4zm-9.44-2.73l1.31-1.37a2.34 2.34 0 0 0 .66-1.66v-5.45a5.75 5.75 0 0 1 1.8-4.15 5.14 5.14 0 0 1 4.16-1.37c1.29.22 2.46.92 3.29 1.97a5.84 5.84 0 0 1 1.25 3.75v5.25a2.43 2.43 0 0 0 .64 1.66l1.33 1.37H17.78zm4.03-19.69a1 1 0 0 1 .46.71 1.13 1.13 0 0 1-.85 1.23c-1.02.19-2 .6-2.86 1.21a7.86 7.86 0 0 0-2.18 2.33c-.52.95-.84 2-.93 3.05-.1 1.06.03 2.12.38 3.09.06.12.09.27.09.41a1.12 1.12 0 0 1-.33.8c-.1.11-.23.2-.37.25a1 1 0 0 1-.41.08.92.92 0 0 1-.88-.77 9.28 9.28 0 0 1-.48-3.97c.13-1.37.55-2.7 1.22-3.92.72-1.2 1.67-2.23 2.79-3.02a9.28 9.28 0 0 1 3.68-1.57.94.94 0 0 1 .67.1z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg817494995a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5 5)",
    d: "M0 0h40v40H0z"
  }))));
});